(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: {} };
  const R = {
    cart: T.routes.cart || '/cart',
    add: (T.routes.cartAdd || '/cart/add') + '.js',
    change: (T.routes.cartChange || '/cart/change') + '.js',
    all: T.routes.all || '/collections/all',
    search: T.routes.search || '/search/suggest'
  };
  const cur = T.currency || '';
  const amt = (c) => (c / 100).toFixed(2);
  const money = (c) => amt(c) + ' ' + cur;         // 121.00 USD (cards, product page)
  const moneyCart = (c) => cur + ' ' + amt(c);     // USD 121.00 (cart, like Mertra)
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const imgUrl = (u, w) => { if (!u) return ''; try { const x = new URL(u, location.origin); x.searchParams.set('width', w); return x.toString(); } catch (_) { return u; } };

  /* ---------- Header height -> page offset ---------- */
  const hdrSection = $('.section-header');
  const setH = () => { if (hdrSection) document.documentElement.style.setProperty('--header-h', Math.ceil(hdrSection.getBoundingClientRect().height + 12) + 'px'); };
  setH();
  window.addEventListener('resize', setH);
  if (hdrSection && 'ResizeObserver' in window) new ResizeObserver(setH).observe(hdrSection);

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(name) {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return false;
    closeSearch();
    $$('[data-drawer].is-open').forEach((o) => o !== d && closeDrawer(o, false));
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock');
    $$(`[data-drawer-open="${name}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const close = $('.drawer__close', d);
    if (close) setTimeout(() => close.focus(), 60);
    return true;
  }
  function closeDrawer(d, restore = true) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lock');
    $$(`[data-drawer-open="${d.dataset.drawer}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (restore && lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'cart' && location.pathname === R.cart) return;
      if (openDrawer(opener.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-drawer]'));
  });

  /* ---------- Inline search in the header bar ---------- */
  const hdr = $('[data-header]');
  const sInput = $('[data-search-input]');
  const sResults = $('[data-search-results]');
  const blur = $('[data-page-blur]');
  let sTimer = null;
  function openSearch() {
    if (!hdr) return false;
    hdr.classList.add('is-searching');
    if (blur) blur.classList.add('is-on');
    setTimeout(() => sInput && sInput.focus(), 30);
    return true;
  }
  function closeSearch() {
    if (!hdr || !hdr.classList.contains('is-searching')) return;
    hdr.classList.remove('is-searching');
    if (blur) blur.classList.remove('is-on');
    if (sResults) { sResults.innerHTML = ''; sResults.classList.remove('has-results'); }
    if (sInput) sInput.value = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { if (openSearch()) e.preventDefault(); return; }
    if (e.target.closest('[data-search-close]') || e.target.closest('[data-page-blur]')) closeSearch();
  });
  async function runSearch(q) {
    if (!sResults) return;
    if (!q.trim()) { sResults.innerHTML = ''; sResults.classList.remove('has-results'); return; }
    try {
      const r = await fetch(`${R.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`, { headers: { Accept: 'application/json' } });
      const data = await r.json();
      const items = (data.resources && data.resources.results && data.resources.results.products) || [];
      sResults.innerHTML = items.length
        ? `<div class="search-results__grid">${items.map((p) => `
            <a class="search-results__item" href="${esc(p.url)}">
              ${p.image ? `<img src="${esc(imgUrl(p.image, 400))}" alt="" loading="lazy">` : ''}
              <p>${esc(p.title)}<b>${p.price ? esc(Number(p.price).toFixed(2)) + ' ' + esc(cur) : ''}</b></p>
            </a>`).join('')}</div>
            <a class="search-results__all" href="/search?type=product&q=${encodeURIComponent(q)}">[ VIEW ALL RESULTS ]</a>`
        : `<p class="search-results__empty">NO PRODUCTS MATCH "${esc(q)}".</p>`;
      sResults.classList.add('has-results');
    } catch (_) { /* the form still submits to the search page */ }
  }
  if (sInput) sInput.addEventListener('input', () => { clearTimeout(sTimer); sTimer = setTimeout(() => runSearch(sInput.value), 220); });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeSearch();
    $$('[data-drawer].is-open').forEach((d) => closeDrawer(d));
  });

  /* ---------- Cart ---------- */
  function cartError(msg) {
    const el = $('[data-cart-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }
  async function getCart() {
    const r = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    const list = $('[data-cart-items]');
    const foot = $('[data-cart-foot]');
    const upsell = $('[data-upsell]');
    if (!list) return;
    if (!cart.item_count) {
      list.innerHTML = '<p class="cart-empty">YOUR CART IS EMPTY.</p>';
      if (foot) foot.hidden = true;
      if (upsell) upsell.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    if (upsell) upsell.hidden = false;
    list.innerHTML = cart.items.map((it, i) => {
      const line = i + 1;
      const opts = (it.options_with_values || []).filter((o) => o.value !== 'Default Title')
        .map((o) => `<p class="cart-item__variant">${esc(o.name)} ${esc(o.value)}</p>`).join('');
      const img = it.image ? `<img src="${esc(imgUrl(it.image, 300))}" alt="${esc(it.product_title)}" loading="lazy">` : '';
      return `<div class="cart-item">
        <a class="cart-item__img" href="${esc(it.url)}">${img}</a>
        <div>
          <a class="cart-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          <p class="cart-item__price">${moneyCart(it.final_line_price)}</p>
          ${opts}
          <div class="qty">
            <button type="button" data-line="${line}" data-q="${it.quantity - 1}" aria-label="Remove one">&minus;</button>
            <span>${it.quantity}</span>
            <button type="button" data-line="${line}" data-q="${it.quantity + 1}" aria-label="Add one">+</button>
          </div>
        </div>
        <button type="button" class="cart-item__remove" data-line="${line}" data-q="0">REMOVE</button>
      </div>`;
    }).join('');
    const sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = moneyCart(cart.total_price);
  }
  async function refreshCart() {
    try { renderCart(await getCart()); } catch (_) { /* keep server-rendered state */ }
  }
  async function addToCart(items, open = true) {
    const r = await fetch(R.add, { method: 'POST', headers: json, body: JSON.stringify({ items }) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'This item could not be added.');
    cartError('');
    await refreshCart();
    if (open) openDrawer('cart');
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line]');
    if (!b) return;
    b.disabled = true;
    try {
      const r = await fetch(R.change, { method: 'POST', headers: json, body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) }) });
      const data = await r.json();
      if (!r.ok) { cartError(data.description || data.message); await refreshCart(); return; }
      cartError('');
      renderCart(data);
    } catch (_) {
      cartError('The cart could not update. Refresh the page and try again.');
    }
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    try { await addToCart([{ id: +b.dataset.quickAdd, quantity: 1 }]); }
    catch (err) { cartError(err.message); await refreshCart(); openDrawer('cart'); }
    finally { b.disabled = false; }
  });
  document.addEventListener('change', async (e) => {
    const s = e.target.closest('[data-upsell-select]');
    if (s && s.value) {
      try { await addToCart([{ id: +s.value, quantity: 1 }]); } catch (err) { cartError(err.message); }
      s.value = '';
    }
    const agree = e.target.closest('[data-cart-agree]');
    if (agree) { const c = $('[data-checkout]'); if (c) c.disabled = !agree.checked; }
  });

  /* ---------- Product cards: image slider ---------- */
  function showSlide(card, next) {
    const slides = $$('.card__slide', card);
    if (slides.length < 2) return;
    let i = slides.findIndex((s) => s.classList.contains('is-active'));
    i = (i + next + slides.length) % slides.length;
    slides.forEach((s, n) => {
      s.classList.toggle('is-active', n === i);
      if (n === i) { const img = $('img[data-src]', s); if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); } }
    });
    $$('.card__dots span', card).forEach((d, n) => d.classList.toggle('is-active', n === i));
  }
  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-card-prev]');
    const next = e.target.closest('[data-card-next]');
    if (!prev && !next) return;
    e.preventDefault();
    showSlide((prev || next).closest('[data-card]'), next ? 1 : -1);
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach((sec) => {
    const dataEl = $('[data-product-json]', sec);
    const form = $('form[data-product-form]', sec);
    if (!dataEl || !form) return;
    const product = JSON.parse(dataEl.textContent);
    const idInput = $('input[name="id"]', form);
    const btn = $('[data-add-button]', sec);
    const priceEl = $('[data-price]', sec);
    const errEl = $('[data-form-error]', sec);
    const sets = $$('fieldset[data-option-index]', sec);
    const single = product.variants.length === 1;
    let current = single ? product.variants[0] : product.variants.find((v) => String(v.id) === idInput.value);

    const selected = () => sets.map((fs) => { const i = $('input:checked', fs); return i ? i.value : null; });
    const match = (opts) => opts.every((o) => o !== null) ? product.variants.find((v) => v.options.every((o, i) => o === opts[i])) : undefined;

    function markAvailability(sel) {
      sets.forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = sel.slice(); test[idx] = inp.value;
          const ok = product.variants.some((v) => v.available && v.options.every((o, i) => test[i] === null || o === test[i]));
          const lab = $(`label[for="${inp.id}"]`, fs);
          if (lab) lab.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function missingName() {
      const sel = selected();
      const i = sel.findIndex((v) => v === null);
      return i >= 0 ? (product.options[i] || 'size') : 'size';
    }
    function setButton() {
      if (!product.available) { btn.disabled = true; btn.textContent = 'SOLD OUT'; return; }
      if (!current) { btn.disabled = true; btn.textContent = 'SELECT ' + String(missingName()).toUpperCase(); return; }
      btn.disabled = !current.available;
      btn.textContent = current.available ? 'ADD TO CART' : 'SOLD OUT';
    }
    function goToMedia(v) {
      if (!v || !v.featured_media) return;
      const el = $(`[data-media-id="${v.featured_media.id}"]`, sec);
      if (!el) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      } else {
        el.parentElement.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
      }
    }
    function update(e) {
      const sel = selected();
      markAvailability(sel);
      current = match(sel);
      setButton();
      const shown = current || product.variants.find((v) => v.options.every((o, i) => sel[i] === null || o === sel[i]));
      if (shown) priceEl.innerHTML = (shown.compare_at_price > shown.price ? `<s>${money(shown.compare_at_price)}</s> ` : '') + money(shown.price);
      if (e && e.target && e.target.closest('.opt--swatch')) goToMedia(shown);
      if (!current) { idInput.value = ''; return; }
      idInput.value = current.id;
      const url = new URL(location.href);
      url.searchParams.set('variant', current.id);
      history.replaceState(null, '', url);
    }
    sets.forEach((fs) => fs.addEventListener('change', update));
    if (sets.length) markAvailability(selected());
    if (single) idInput.value = product.variants[0].id;
    setButton();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!current || !current.available) return;
      errEl.hidden = true;
      btn.disabled = true;
      btn.textContent = 'ADDING';
      try { await addToCart([{ id: +idInput.value, quantity: 1 }]); }
      catch (err) { errEl.textContent = err.message; errEl.hidden = false; }
      finally { setButton(); }
    });

    // Pair product (ADD [PRODUCT] row)
    $$('[data-pair-add]', sec).forEach((b) => b.addEventListener('click', async () => {
      b.disabled = true;
      try { await addToCart([{ id: +b.dataset.pairAdd, quantity: 1 }]); b.classList.add('is-added'); }
      catch (err) { errEl.textContent = err.message; errEl.hidden = false; }
      finally { b.disabled = false; }
    }));

    // Thumbnails
    const thumbs = $$('[data-thumb]', sec);
    const medias = $$('.pdp__image', sec);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const el = medias[+t.dataset.thumb];
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    }));
    if (thumbs.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          const i = medias.indexOf(en.target);
          thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      medias.forEach((m) => io.observe(m));
    }

    // Complete the fit
    const fit = $('[data-fit]', sec);
    if (fit) {
      const load = async (url) => {
        const r = await fetch(url);
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = $$('[data-recs-items] .card', doc).slice(0, 2);
        return items;
      };
      (async () => {
        try {
          let items = await load(fit.dataset.url);
          if (!items.length) items = await load(fit.dataset.fallback);
          if (!items.length) return;
          $('[data-fit-grid]', fit).append(...items);
          fit.hidden = false;
        } catch (_) { /* optional */ }
      })();
    }
  });

  /* ---------- Recommended section ---------- */
  $$('[data-recs]').forEach(async (sec) => {
    if ($('[data-recs-items]', sec)) return;
    try {
      const r = await fetch(sec.dataset.url);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) sec.innerHTML = fresh.innerHTML;
    } catch (_) { /* optional */ }
  });

  /* ---------- Collection: 2 / 4 / 6 columns ---------- */
  $$('[data-collection]').forEach((sec) => {
    const grid = $('[data-grid]', sec);
    $$('[data-cols]', sec).forEach((b) => {
      if (b === grid) return;
      b.addEventListener('click', () => {
        grid.dataset.cols = b.dataset.cols;
        $$('button[data-cols]', sec).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      });
    });
  });

  /* ---------- Footer NEED HELP? ---------- */
  const help = $('[data-footer-help]');
  if (help) help.addEventListener('click', () => {
    const menu = $('[data-footer-menu]');
    const open = help.getAttribute('aria-expanded') !== 'true';
    help.setAttribute('aria-expanded', String(open));
    if (menu) menu.classList.toggle('is-open', open);
  });

  /* ---------- Timeline progress line ---------- */
  const tl = $('[data-timeline]');
  if (tl) {
    const fill = $('.tl__fill', tl);
    let ticking = false;
    const run = () => {
      const r = tl.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (window.innerHeight * 0.6 - r.top) / r.height));
      fill.style.height = (p * 100).toFixed(2) + '%';
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- Currency selector ---------- */
  $$('[data-localization] select').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  refreshCart();
})();
